import type { Province } from "../types";

export const provinces: Province[] = [
  { id: "CN-XJ", code: "65", name: "新疆", shortName: "新", row: 1, col: 1 },
  { id: "CN-GS", code: "62", name: "甘肃", shortName: "甘", row: 2, col: 3 },
  { id: "CN-NM", code: "15", name: "内蒙古", shortName: "蒙", row: 1, col: 5 },
  { id: "CN-HL", code: "23", name: "黑龙江", shortName: "黑", row: 1, col: 9 },
  { id: "CN-JL", code: "22", name: "吉林", shortName: "吉", row: 2, col: 9 },
  { id: "CN-LN", code: "21", name: "辽宁", shortName: "辽", row: 3, col: 9 },
  { id: "CN-BJ", code: "11", name: "北京", shortName: "京", row: 3, col: 7 },
  { id: "CN-TJ", code: "12", name: "天津", shortName: "津", row: 3, col: 8 },
  { id: "CN-HE", code: "13", name: "河北", shortName: "冀", row: 4, col: 7 },
  { id: "CN-SX", code: "14", name: "山西", shortName: "晋", row: 4, col: 6 },
  { id: "CN-NX", code: "64", name: "宁夏", shortName: "宁", row: 4, col: 4 },
  { id: "CN-QH", code: "63", name: "青海", shortName: "青", row: 4, col: 3 },
  { id: "CN-XZ", code: "54", name: "西藏", shortName: "藏", row: 5, col: 1 },
  { id: "CN-SN", code: "61", name: "陕西", shortName: "陕", row: 5, col: 5 },
  { id: "CN-SD", code: "37", name: "山东", shortName: "鲁", row: 5, col: 8 },
  { id: "CN-HA", code: "41", name: "河南", shortName: "豫", row: 6, col: 6 },
  { id: "CN-JS", code: "32", name: "江苏", shortName: "苏", row: 6, col: 8 },
  { id: "CN-AH", code: "34", name: "安徽", shortName: "皖", row: 7, col: 7 },
  { id: "CN-SH", code: "31", name: "上海", shortName: "沪", row: 7, col: 9 },
  { id: "CN-SC", code: "51", name: "四川", shortName: "川", row: 7, col: 4 },
  { id: "CN-CQ", code: "50", name: "重庆", shortName: "渝", row: 7, col: 5 },
  { id: "CN-HB", code: "42", name: "湖北", shortName: "鄂", row: 7, col: 6 },
  { id: "CN-ZJ", code: "33", name: "浙江", shortName: "浙", row: 8, col: 8 },
  { id: "CN-JX", code: "36", name: "江西", shortName: "赣", row: 8, col: 7 },
  { id: "CN-HN", code: "43", name: "湖南", shortName: "湘", row: 8, col: 6 },
  { id: "CN-GZ", code: "52", name: "贵州", shortName: "黔", row: 8, col: 5 },
  { id: "CN-YN", code: "53", name: "云南", shortName: "滇", row: 9, col: 4 },
  { id: "CN-FJ", code: "35", name: "福建", shortName: "闽", row: 9, col: 8 },
  { id: "CN-GX", code: "45", name: "广西", shortName: "桂", row: 9, col: 6 },
  { id: "CN-GD", code: "44", name: "广东", shortName: "粤", row: 10, col: 7 },
  { id: "CN-HI", code: "46", name: "海南", shortName: "琼", row: 11, col: 7 },
  { id: "CN-HK", code: "81", name: "香港", shortName: "港", row: 10, col: 8 },
  { id: "CN-MO", code: "82", name: "澳门", shortName: "澳", row: 11, col: 8 },
  { id: "CN-TW", code: "71", name: "台湾", shortName: "台", row: 10, col: 9 }
];

export const provinceByAdminCode = new Map(
  provinces.map((province) => [province.code, province])
);

export const provinceById = new Map(
  provinces.map((province) => [province.id, province])
);

export const cityProvinceFallback: Record<string, string> = {
  北京市: "CN-BJ",
  天津市: "CN-TJ",
  上海市: "CN-SH",
  重庆市: "CN-CQ",
  哈尔滨市: "CN-HL",
  长春市: "CN-JL",
  沈阳市: "CN-LN",
  大连市: "CN-LN",
  南京市: "CN-JS",
  杭州市: "CN-ZJ",
  石家庄市: "CN-HE",
  合肥市: "CN-AH",
  蚌埠市: "CN-AH",
  徐州市: "CN-JS",
  福州市: "CN-FJ",
  南昌市: "CN-JX",
  济南市: "CN-SD",
  青岛市: "CN-SD",
  烟台市: "CN-SD",
  潍坊市: "CN-SD",
  郑州市: "CN-HA",
  武汉市: "CN-HB",
  长沙市: "CN-HN",
  广州市: "CN-GD",
  桂林市: "CN-GX",
  成都市: "CN-SC",
  西安市: "CN-SN",
  兰州市: "CN-GS",
  西宁市: "CN-QH",
  银川市: "CN-NX",
  乌鲁木齐市: "CN-XJ"
};

export const scopeLabels: Record<string, string> = {
  all: "全部高校",
  ordinary: "普通高校",
  undergraduate: "本科",
  vocational: "专科",
  private: "民办",
  military: "军校"
};
